import React, { useEffect, useState } from "react";
import { authFetch, getToken, isEmpleado, getSocioId } from "../services/auth";

const DocumentList = ({ reload = 0, socioId: socioIdProp }) => {
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    // ⛔ No llames sin token (evita 401 y bucles)
    if (!getToken()) return;

    const ctrl = new AbortController();
    const run = async () => {
      setLoading(true);
      setErrorMsg("");
      try {
        // Decide endpoint: empleado ve global (/api/documentos/), socio ve solo los suyos
        let url;
        if (isEmpleado()) {
          url = "/api/documentos/";
        } else {
          const myId = socioIdProp ?? getSocioId();
          url = myId ? `/api/socios/${myId}/documentos` : "/api/documentos/";
        }

        const r = await authFetch(url, { signal: ctrl.signal });
        if (!r.ok) {
          if (r.status === 403) {
            setErrorMsg("No tienes permiso para ver estos documentos.");
          } else {
            const txt = await r.text().catch(() => "");
            setErrorMsg(`Error ${r.status}${txt ? `: ${txt}` : ""}`);
          }
          setDocumentos([]);
          return;
        }
        const data = await r.json();
        setDocumentos(Array.isArray(data) ? data : []);
      } catch (e) {
        if (e.name !== "AbortError") {
          setErrorMsg("No se pudieron cargar los documentos.");
          setDocumentos([]);
        }
      } finally {
        setLoading(false);
      }
    };
    run();

    return () => ctrl.abort();
  }, [reload, socioIdProp]);

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">📋 Lista de documentos</h2>

      {loading && <p className="text-gray-500">Cargando…</p>}

      {!loading && errorMsg && (
        <p className="text-red-600">{errorMsg}</p>
      )}

      {!loading && !errorMsg && documentos.length === 0 && (
        <p className="text-gray-500">No hay documentos disponibles.</p>
      )}

      {!loading && !errorMsg && documentos.length > 0 && (
        <ul className="space-y-3">
          {documentos.map((doc, index) => (
            <li
              key={doc.id ?? index}
              className="border p-4 rounded-lg shadow-sm bg-gray-50"
            >
              <p><strong>📄 Nombre:</strong> {doc.nombre ?? doc.nombre_archivo ?? "documento"}</p>
              <p><strong>🗂️ Tipo:</strong> {doc.tipo ?? "—"}</p>
              <p><strong>📆 Subido:</strong> {doc.fecha_subida ?? "—"}</p>
              <p><strong>⏳ Caduca:</strong> {doc.fecha_caducidad ?? "—"}</p>
              <p><strong>👤 Propietario:</strong> {doc.propietario ?? "—"}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DocumentList;
